import { render, staticRenderFns } from "./CustomerCouponsRedeem.vue?vue&type=template&id=05cfead0"
import script from "./CustomerCouponsRedeem.vue?vue&type=script&lang=js"
export * from "./CustomerCouponsRedeem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports